import { useContext, useMemo } from "react";
import { SearchContext } from "../../contexts/SearchContext";

export function useSearch() {
    const context = useContext(SearchContext);

    const paths = useMemo(() => [
        { href: '/search', name: 'Ocorrências' },
        { href: '', name: 'Ocorrências em Aberto' },
    ], []);

    return {
        paths,
        ...context,
    }
}